'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _humps = require('humps');

var convertMol = function convertMol(target) {
  var mol = target.mol;

  var data = new FormData();
  data.append('molfile', mol);

  var promise = fetch('/api/v1/chemspectra/molfile/convert', {
    credentials: 'same-origin',
    method: 'post',
    body: data
  }).then(function (response) {
    return response.json();
  }).then(function (json) {
    return (0, _humps.camelizeKeys)(json);
  }).catch(function (err) {
    console.log(err); // eslint-disable-line
  });

  return promise;
};

var FetcherMol = {
  convertMol: convertMol
};

exports.default = FetcherMol;